import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { projects } from '../../mocks/projects';

export default function Projects() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center bg-gradient-to-r from-teal-600 to-teal-700">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="relative z-10 text-center text-white px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">시공사례</h1>
          <p className="text-lg md:text-xl text-white/90">
            전국 주요 하천정비 프로젝트 수행 실적
          </p>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">주요 프로젝트</h2>
            <p className="text-lg text-gray-600">
              다양한 현장에서 검증된 기술력과 시공 품질을 확인하세요.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {projects.map((project) => (
              <div key={project.id} className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-lg transition-shadow">
                <div className="w-full h-64">
                  <img 
                    src={project.image} 
                    alt={project.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-6">
                  <div className="inline-block px-3 py-1 bg-teal-100 text-teal-700 text-xs font-medium rounded-full mb-3">
                    {project.category}
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{project.title}</h3>
                  <div className="flex items-center text-sm text-gray-600 mb-3">
                    <i className="ri-map-pin-line mr-2"></i>
                    <span>{project.location}</span>
                    <span className="mx-2">·</span>
                    <span>{project.year}</span>
                  </div>
                  <p className="text-sm text-gray-600 leading-relaxed">{project.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Project Process */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">시공 프로세스</h2>
            <p className="text-lg text-gray-600">
              체계적인 시공 절차로 최상의 결과를 제공합니다.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white p-8 rounded-lg shadow-sm text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-2xl font-bold text-teal-600">1</span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">현장 조사</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                현장 여건 및 지형 조건을 면밀히 조사하고 분석합니다.
              </p>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-sm text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-2xl font-bold text-teal-600">2</span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">설계 및 계획</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                현장 조건에 최적화된 설계안을 수립하고 시공 계획을 작성합니다.
              </p>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-sm text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-2xl font-bold text-teal-600">3</span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">제품 제작</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                엄격한 품질관리 하에 현장 맞춤형 제품을 제작합니다.
              </p>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-sm text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-2xl font-bold text-teal-600">4</span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">시공 및 완공</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                전문 기술진의 지도 하에 시공을 진행하고 품질을 검증합니다.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Before/After Comparison */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">시공 전후 비교</h2>
            <p className="text-lg text-gray-600">
              매트리스개비온 시공으로 달라진 하천의 모습
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="bg-gray-50 rounded-lg overflow-hidden shadow-sm">
              <div className="w-full h-80">
                <img 
                  src="https://public.readdy.ai/ai/img_res/088682c81e11ff4c20ea10aaacc69e9c.jpg" 
                  alt="시공 전"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <div className="inline-block px-3 py-1 bg-red-100 text-red-700 text-xs font-semibold rounded-full mb-3">
                  시공 전
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">침식된 하천 호안</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  장기간 침식으로 인해 호안이 붕괴되고 구조적 안정성이 저하된 상태입니다.
                </p>
              </div>
            </div>

            <div className="bg-gray-50 rounded-lg overflow-hidden shadow-sm">
              <div className="w-full h-80">
                <img 
                  src="https://readdy.ai/api/search-image?query=After%20construction%20photo%20of%20beautifully%20restored%20riverbank%20with%20newly%20installed%20gabion%20mattress%20protection%20system%2C%20stable%20structure%20with%20hexagonal%20wire%20mesh%20filled%20with%20natural%20stones%2C%20erosion%20completely%20prevented%2C%20improved%20embankment%20condition%2C%20clear%20flowing%20water%2C%20green%20vegetation%20growing%2C%20successful%20river%20management%20result%2C%20professional%20construction%20photography%2C%20high%20quality%20engineering%20achievement&width=800&height=600&seq=after1new&orientation=landscape" 
                  alt="시공 후"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <div className="inline-block px-3 py-1 bg-green-100 text-green-700 text-xs font-semibold rounded-full mb-3">
                  시공 후
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">안정화된 하천 호안</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  매트리스개비온 시공으로 구조적 안정성이 확보되고 침식이 방지되었습니다.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Client Testimonials */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">고객 평가</h2>
            <p className="text-lg text-gray-600">
              우진에코텍과 함께한 고객사의 평가
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-lg shadow-sm">
              <div className="flex items-center mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
              </div>
              <p className="text-sm text-gray-600 mb-6 leading-relaxed">
                "제품 품질이 우수하고 현장 기술 지원이 체계적이어서 공사를 원활하게 진행할 수 있었습니다."
              </p>
              <div className="flex items-center">
                <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-building-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h4 className="text-sm font-bold text-gray-900">○○건설 현장소장</h4>
                  <p className="text-xs text-gray-500">△△천 하천정비 사업</p>
                </div>
              </div>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-sm">
              <div className="flex items-center mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
              </div>
              <p className="text-sm text-gray-600 mb-6 leading-relaxed">
                "납기를 정확히 준수하고 제품 품질이 일정하여 신뢰할 수 있는 파트너입니다."
              </p>
              <div className="flex items-center">
                <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-building-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h4 className="text-sm font-bold text-gray-900">□□토목 구매담당</h4>
                  <p className="text-xs text-gray-500">◇◇강 침식방지 공사</p>
                </div>
              </div>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-sm">
              <div className="flex items-center mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
              </div>
              <p className="text-sm text-gray-600 mb-6 leading-relaxed">
                "현장 맞춤형 제작과 신속한 대응으로 공기를 단축할 수 있었습니다."
              </p>
              <div className="flex items-center">
                <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-government-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h4 className="text-sm font-bold text-gray-900">☆☆시청 담당공무원</h4>
                  <p className="text-xs text-gray-500">생태하천 조성사업</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
